<script setup>
  const top = useTop()
  const config = useRuntimeConfig()

  const scrollTop = () => {
    window.scrollTo({ behavior: 'smooth', top: 0 })
  }

  const socialNetworks = [{ class: 'hover:text-linkedin', icon: 'fa-brands fa-linkedin-in', to: 'https://www.linkedin.com/company/profilpublic' }]
</script>

<template>
  <footer class="relative z-20" ref="footer">
    <div class="bg-tarawera-900">
      <div class="mx-auto flex max-w-screen-xl flex-col justify-center md:flex-row">
        <div class="flex flex-1 flex-wrap items-start py-4 text-white">
          <FooterNewsletter class="w-full p-4 sm:flex-1 lg:order-last" />

          <div class="w-full space-x-8 p-4 md:hidden">
            <NuxtLink class="duration-300" v-for="link in socialNetworks" :class="link.class" target="_blank" :to="link.to">
              <FontAwesomeIcon :icon="link.icon" fixed-width size="lg" />
            </NuxtLink>
          </div>

          <div class="p-4 sm:order-first lg:order-2">
            <ul class="space-y-1 sm:space-y-2">
              <li
                v-for="link in [
                  { text: 'Notre ATS Profil Public', to: '/ats-profilpublic' },
                  { text: 'Nos partenaires', to: '/nos-partenaires' },
                  { text: 'Qui sommes-nous', to: `https://${config.public.careerDomain}/profil-public`, target: '_blank' },
                  { text: 'Nous contacter', to: '/contact' },
                  { text: 'Nos jeux de cartes', to: 'https://media.profilpublic.fr/boutique', target: '_blank' },
                  { text: 'Déposer un CV', to: '/depot-cv' }
                ]"
              >
                <NuxtLink class="group duration-300 hover:text-viking-500" :target="link.target" :to="link.to">
                  <FontAwesomeIcon
                    class="text-viking-400 duration-300 group-hover:text-inherit"
                    fixed-width
                    icon="fa-solid fa-angle-right"
                    size="2xs"
                  />
                  {{ link.text }}
                </NuxtLink>
              </li>
            </ul>
          </div>

          <div class="flex w-full justify-center p-4 lg:order-first lg:w-auto">
            <div class="relative pb-4 pl-14 pr-10 pt-4 font-special text-2xl font-bold">
              <NuxtImg class="absolute -top-5 left-0 mx-auto aspect-square h-20 opacity-50" src="/images/quote.svg" alt="Quote" />
              <NuxtImg class="absolute bottom-0 right-0 h-12 w-12 rounded-full" src="/images/avatar-profil-public.svg" alt="Logo Profil Public" />
              <div class="relative">Accélérez vos<br />recrutements dans<br />le service public&nbsp;!</div>
            </div>
          </div>
        </div>

        <div class="ml-4 hidden flex-col items-center justify-center space-y-6 bg-white p-4 md:flex">
          <NuxtLink class="duration-300" v-for="link in socialNetworks" :class="link.class" target="_blank" :to="link.to">
            <FontAwesomeIcon :icon="link.icon" fixed-width size="lg" />
          </NuxtLink>
        </div>
      </div>
    </div>

    <div class="bg-viking-400">
      <div class="mx-auto flex max-w-screen-xl flex-col flex-wrap items-center justify-center px-4 py-2 text-sm lg:flex-row">
        <div>©&nbsp;Profil Public. Tous droits réservés.</div>
        <div class="ml-5 mt-1 flex flex-col items-center justify-center sm:flex-row sm:space-x-2 lg:mt-0">
          <NuxtLink class="duration-300 hover:text-white" to="/mentions-legales">Mentions légales</NuxtLink>
          <div class="hidden text-viking-600 sm:inline">-</div>
          <NuxtLink class="duration-300 hover:text-white" to="/conditions-generales">Conditions générales</NuxtLink>
          <div class="hidden text-viking-600 sm:inline">-</div>
          <NuxtLink class="duration-300 hover:text-white" to="/politique-de-donnees">Politique de données</NuxtLink>
        </div>
      </div>
    </div>

    <transition enter-from-class="opacity-0" enter-to-class="opacity-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
      <div class="fixed bottom-16 right-2 duration-500 md:right-4" v-if="!top">
        <button
          class="hidden h-8 w-8 items-center justify-center rounded bg-viking-400 text-white shadow-lg backdrop-blur duration-300 hover:bg-viking-500 md:flex"
          @click="scrollTop"
        >
          <FontAwesomeIcon icon="fa-solid fa-chevron-up" />
        </button>
      </div>
    </transition>
  </footer>
</template>
